// 商品库管理-商品基础库
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Form,
  Button,
  Input,
  Table,
  Modal,
  Select,
  Divider,
  message,
  TreeSelect,
} from 'antd-v5';
import PageHeaderLayout from '../../../component/page-header-layout/index';
import './index.less';
import {
  addSpuRequest,
  countSpuRequest,
  deleteSpuRequest,
  editSpuRequest,
  getSpuCategoryTreeListRequest,
  mergeSpuRequest,
  pageSpuRequest,
} from '../../../state/request/cxmProductSpuCategory';
import SpuFormModal from './spuFormModal';

const { Column } = Table;

const { confirm } = Modal;

const titleMap = {
  add: '新增基库货品（SPU）',
  update: '编辑基库货品（SPU）',
  merge: '合并SPU',
};

@connect((state) => {
  return {};
}, {})
class CommodityBase extends PureComponent {
  constructor(props) {
    super(props);
    const { searchValues, defaultCurrent } = this.props.history.location.state || {};
    this.state = {
      loading: false,
      rows: {},
      visible: false,
      operationType: '',
      defaultCurrent: defaultCurrent || 1, //当前页
      searchValues: searchValues || {},
      selectedRowKeys: [],
      selectedRows: [],
      dataSource: {},
      treeData: [],
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.getSupPage(); // 获取商品基库列表
    this.getSpuCategoryList();
    this.formRef.current.setFieldsValue(this.state.searchValues);
  }

  getSpuCategoryList = async () => {
    const res = await getSpuCategoryTreeListRequest();
    if (res?.code === 200) {
      this.setState({ treeData: res.data });
    }
  };

  // 获取商品基库列表
  async getSupPage() {
    this.setState({ loading: true });
    const { defaultCurrent, searchValues } = this.state;
    const params = {
      ...searchValues,
      pageNo: defaultCurrent,
      pageSize: 10,
    };
    const res = await pageSpuRequest(params);
    this.setState({ loading: false });
    if (res.code === 200) {
      this.setState({
        dataSource: res.data,
      });
    }
  }
  convertToTreeData = (data, disabled = false) => {
    if (!Array.isArray(data)) return [];
    return data.map((item) => ({
      title: item.name,
      value: item.id,
      level: item.level,
      disabled: disabled ? item.level === 1 || item.level === 2 : false,
      children: this.convertToTreeData(item.childNodeList, disabled),
    }));
  };

  isUndefied = (value) => {
    return value || null;
  };

  // 查询
  handleSumbit = (values) => {
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: values,
      },
      () => {
        this.getSupPage();
      },
    );
  };
  // 重置
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: {},
      },
      () => {
        this.getSupPage();
      },
    );
  };

  pageSwitch = (obj) => {
    this.setState(
      {
        defaultCurrent: obj.current,
      },
      () => {
        this.getSupPage();
      },
    );
  };

  // 新增、编辑
  showGoodsModal = (rows, visible, operationType) => {
    this.setState({
      rows,
      visible,
      operationType,
    });
  };

  // 新增、编辑保存按钮
  editHandleSubmit = async (values) => {
    const { rows, defaultCurrent, operationType, selectedRowKeys } = this.state;
    const params = {
      ...values,
    };
    const isMerge = operationType === 'merge';
    if (isMerge) {
      params.spuIdList = selectedRowKeys;
    } else if (rows.id) {
      params.id = rows.id;
    }
    const API = isMerge ? mergeSpuRequest : params.id ? editSpuRequest : addSpuRequest;
    const res = await API(params);
    if (res.code === 200) {
      message.success(isMerge ? '合并成功' : params.id ? '修改成功' : '保存成功');
      this.setState(
        {
          visible: false,
          defaultCurrent: isMerge ? 1 : params.id ? defaultCurrent : 1,
          ...(isMerge ? { selectedRowKeys: [], selectedRows: [] } : {}),
        },
        () => {
          this.getSupPage();
        },
      );
    }
  };

  // 维护别名
  gotoGoods = (rows) => {
    this.props.history.push({
      pathname: '/commodityManage2.0/commodityBase/addAlias',
      state: {
        rows,
        searchValues: this.state.searchValues,
        defaultCurrent: this.state.defaultCurrent,
      },
    });
  };

  // 删除
  delete = async (record) => {
    const that = this;
    const res = await countSpuRequest({ id: record.id });
    if (res.code === 200) {
      confirm({
        title: '提示',
        content: (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 'bold' }}>{`确定删除基库货品【${record.name}】吗？`}</div>
            <div>{`已关联商行货品【${res.data}】个`}</div>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.deleteCommodity(record.id);
        },
        onCancel() {},
      });
    }
  };

  async deleteCommodity(id) {
    const res = await deleteSpuRequest(id);
    if (res.code === 200) {
      message.success('删除成功');
      this.getSupPage();
    }
  }
  onSelectChange = (newSelectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys: newSelectedRowKeys,
      selectedRows,
    });
  };
  mergeSPU = () => {
    const { selectedRowKeys, selectedRows } = this.state;
    if (selectedRowKeys.length < 2) {
      message.warning('请先勾选至少2个SPU后再操作!');
      return;
    }
    this.showGoodsModal(selectedRows[0], true, 'merge');
  };

  render() {
    const {
      loading,
      rows,
      visible,
      defaultCurrent,
      selectedRowKeys,
      treeData,
      dataSource,
      operationType,
    } = this.state;
    const { pageList, totalSize } = dataSource;
    const pagination = {
      pageSize: 10,
      total: totalSize,
      current: defaultCurrent,
      showSizeChanger: false,
    };
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <div className='commodity-index'>
        <PageHeaderLayout>
          <div className='commodityManage'>
            <Form
              ref={this.formRef}
              onFinish={this.handleSumbit}
              layout='inline'
              style={{ marginBottom: 12 }}
            >
              <Form.Item label='基库货品' name='name'>
                <Input style={{ width: 200 }} placeholder='请输入基库货品' allowClear />
              </Form.Item>
              <Form.Item label='货品分类' name='categoryId'>
                <TreeSelect
                  style={{ width: 200 }}
                  treeLine
                  treeDefaultExpandAll
                  placeholder='请选择货品分类'
                  allowClear
                  showSearch
                  treeData={this.convertToTreeData(treeData, false)}
                  filterTreeNode={(input, treeNode) => {
                    return treeNode.props.title.indexOf(input) >= 0;
                  }}
                />
              </Form.Item>
              <Form.Item>
                <Button type='primary' htmlType='submit'>
                  查询
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                  重置
                </Button>
                <Button
                  type='primary'
                  style={{ marginLeft: 8 }}
                  onClick={() => this.showGoodsModal({}, true, 'add')}
                >
                  新增货品
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={this.mergeSPU}>
                  合并SPU
                </Button>
              </Form.Item>
            </Form>
            <Table
              rowKey={(_, index) => _.id}
              dataSource={pageList}
              pagination={pagination}
              rowSelection={rowSelection}
              bordered
              loading={loading}
              onChange={this.pageSwitch.bind(this)}
            >
              <Column title='SPU' dataIndex='id' key='id' width='100px' />
              <Column title='基库货品' dataIndex='name' key='name' />
              <Column title='货品分类' dataIndex='categoryName' key='categoryName' />
              <Column
                title='操作'
                dataIndex='option'
                key='option'
                width={200}
                render={(_, record) => {
                  return (
                    <div>
                      <a
                        href='/'
                        onClick={(e) => {
                          e.preventDefault();
                          this.gotoGoods(record);
                        }}
                      >
                        查看详情
                      </a>
                      <Divider type='vertical' />
                      <a
                        href='/'
                        onClick={(e) => {
                          e.preventDefault();
                          this.showGoodsModal(record, true, 'update');
                        }}
                      >
                        编辑
                      </a>
                      <Divider type='vertical' />
                      <a
                        href='/'
                        onClick={(e) => {
                          e.preventDefault();
                          this.delete(record);
                        }}
                      >
                        删除
                      </a>
                    </div>
                  );
                }}
              />
            </Table>
            {/** 新增货品、 修改货品 */}
            <SpuFormModal
              title={titleMap[operationType]}
              treeData={this.convertToTreeData(treeData, true)}
              visible={visible}
              onCancel={() => this.showGoodsModal({}, false)}
              onSave={this.editHandleSubmit}
              rows={rows}
            />
          </div>
        </PageHeaderLayout>
      </div>
    );
  }
}

export default CommodityBase;
